export function formatPrice(price) {
  if (typeof price !== 'number') {
    price = Number(price) || 0;
  }
  return `Rs. ${price.toLocaleString('en-US')}`;
}

export function calculateDiscount(originalPrice, currentPrice) {
  if (!originalPrice || originalPrice <= currentPrice) return 0;
  return Math.round(((originalPrice - currentPrice) / originalPrice) * 100);
}

export function formatWhatsAppNumber(number) {
  const cleaned = (number || '').replace(/\D/g, '');
  if (cleaned.startsWith('0')) {
    return '92' + cleaned.slice(1);
  }
  if (cleaned.startsWith('92')) {
    return cleaned;
  }
  return '92' + cleaned;
}